// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_DocumentID from "../Ouroboros.Models.Brands.DocumentID/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Clients_Content from "../Ouroboros.Models.Clients.Content/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Controllers_JwtSession from "../Ouroboros.Programs.Controllers.JwtSession/index.js";
import * as Ouroboros_Services_FFI_Effect from "../Ouroboros.Services.FFI.Effect/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var validationError = function (message) {
    return {
        type: "ValidationError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var unauthorizedError = /* #__PURE__ */ (function () {
    return {
        type: "Unauthorized",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Unauthorized"),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var serverError = function (status) {
    return {
        type: "ServerError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Server responded with an error: " + show(status)),
        statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
    };
};
var serverErrorWithBody = function (status) {
    return function (body) {
        var cleaned = Data_String_Common.trim(body);
        var $17 = cleaned === "";
        if ($17) {
            return serverError(status);
        };
        return {
            type: "ServerError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(cleaned),
            statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
        };
    };
};
var readErrorBody = function (response) {
    return Ouroboros_Services_FFI_Effect.catchAll(Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
        return Ouroboros_Services_FFI_Http.responseText(response);
    })(function (v) {
        return validationError("Response body unavailable");
    }))(function (v) {
        return Ouroboros_Services_FFI_Effect.succeed("");
    });
};
var parseJson = function (response) {
    return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
        return Ouroboros_Services_FFI_Http.responseJson(response);
    })(function (v) {
        return validationError("Response validation failed");
    });
};
var networkError = /* #__PURE__ */ (function () {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Failed to connect to the server. Please check your internet connection."),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var handleUnauthorized = function (onUnauthorized) {
    return Ouroboros_Services_FFI_Effect.fromIO(Ouroboros_Programs_Controllers_JwtSession.actionEffect(onUnauthorized));
};
var fetchWithTrace = function (url) {
    return function (init) {
        return Ouroboros_Services_FFI_Effect.tryPromise(function (v) {
            return Ouroboros_Services_FFI_Http.fetch_(url)(init);
        })(function (v) {
            return networkError;
        });
    };
};
var ensureOk = function (onUnauthorized) {
    return function (response) {
        var $18 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
        if ($18) {
            return Ouroboros_Services_FFI_Effect.flatMap(handleUnauthorized(onUnauthorized))(function (v) {
                return Ouroboros_Services_FFI_Effect.fail(unauthorizedError);
            });
        };
        var $19 = !Ouroboros_Services_FFI_Http.responseOk(response);
        if ($19) {
            return Ouroboros_Services_FFI_Effect.flatMap(readErrorBody(response))(function (body) {
                return Ouroboros_Services_FFI_Effect.fail(serverErrorWithBody(Ouroboros_Services_FFI_Http.responseStatus(response))(body));
            });
        };
        return Ouroboros_Services_FFI_Effect.succeed(response);
    };
};
var documentHeaders = function (documentId) {
    return function (headers) {
        return traceHeaders(append(headers)([ new Data_Tuple.Tuple("X-Document-ID", Ouroboros_Models_Brands_DocumentID.unwrap(documentId)) ]));
    };
};
var decodeResponse = function (onUnauthorized) {
    return function (response) {
        return function (decoder) {
            return function (message) {
                return Ouroboros_Services_FFI_Effect.flatMap(ensureOk(onUnauthorized)(response))(function (okResponse) {
                    return Ouroboros_Services_FFI_Effect.flatMap(parseJson(okResponse))(function (payload) {
                        var v = decoder(payload);
                        if (v instanceof Data_Either.Left) {
                            return Ouroboros_Services_FFI_Effect.fail(validationError(message));
                        };
                        if (v instanceof Data_Either.Right) {
                            return Ouroboros_Services_FFI_Effect.succeed(v.value0);
                        };
                        throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Content (line 108, column 7 - line 110, column 45): " + [ v.constructor.name ]);
                    });
                });
            };
        };
    };
};
var createDefaultContentClient = function (onUnauthorized) {
    return {
        refineSection: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/refine")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_Content.decodeRefineResponse)("Invalid section refine payload");
                });
            };
        },
        replaceSection: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/replace-section")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_Content.decodeReplaceSectionResponse)("Invalid replace section payload");
                });
            };
        },
        answerSectionQuestions: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/answer-section-questions")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_Content.decodeAnswerSectionQuestionsResponse)("Invalid answer section questions payload");
                });
            };
        },
        generateSectionQuestions: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/generate-section-questions")(Ouroboros_Services_FFI_Http.requestInitJson("PUT")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_Content.decodeGenerateSectionQuestionsResponse)("Invalid generate section questions payload");
                });
            };
        },
        answerDocumentQuestions: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/answer-document-questions")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return Ouroboros_Services_FFI_Effect.map(function (v) {
                        return Ouroboros_Models_Core_Ok.ok;
                    })(ensureOk(onUnauthorized)(response));
                });
            };
        },
        generateDocumentQuestions: function (documentId) {
            return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/generate-document-questions")(Ouroboros_Services_FFI_Http.requestInitNoBody("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))))(function (response) {
                return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_Content.decodeGenerateDocumentQuestionsResponse)("Invalid generate document questions payload");
            });
        },
        appendSection: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/append-section")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return decodeResponse(onUnauthorized)(response)(Ouroboros_Models_Clients_Content.decodeAppendSectionResponse)("Invalid append section payload");
                });
            };
        },
        uploadSupplementalDocument: function (documentId) {
            return function (request) {
                return Ouroboros_Services_FFI_Effect.flatMap(fetchWithTrace(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/upload-supplemental")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(documentHeaders(documentId)([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                    return Ouroboros_Services_FFI_Effect.map(function (v) {
                        return Ouroboros_Models_Core_Ok.ok;
                    })(ensureOk(onUnauthorized)(response));
                });
            };
        }
    };
};
export {
    createDefaultContentClient
};
//# sourceMappingURL=index.js.map
